import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { AdornisFile } from '@adornis/file-utils/db/files.js';
import { validate } from '@adornis/validation/decorators.js';
import { nonOptional } from '@adornis/validation/functions/nonOptional.js';
import { DateTime } from 'luxon';

// FIXME: user who can see the document are currently also able to change the share-permission
@Entity()
export class WorkshopDocument extends MongoEntity {
  public static override _class = 'WorkshopDocument';
  public static override _collectionName = 'workshop-documents';

  @Field(type => String)
  @validate(nonOptional())
  title!: string;

  @Field(type => DateTime, { default: v => v ?? DateTime.now() })
  createdAt!: DateTime;

  @Field(type => String)
  text?: string;

  @Field(type => String)
  fileID!: string;

  @Field(type => AdornisFile, {
    resolve: function (this: WorkshopDocument) {
      return async gqlFields => (await getCollection(AdornisFile._class)).findOne<AdornisFile>({ _id: this.fileID });
    },
  })
  file: Maybe<AdornisFile>;

  @validate(nonOptional())
  @Field(type => String)
  public workshopID!: string;

  @Field(type => Boolean, { default: v => v ?? false })
  sharedWithParticipantsWithSuccessfullParticipation: Maybe<boolean>;

  @Field(type => Boolean, { default: v => v ?? false })
  sharedWithParticipantsWithoutSuccessfullParticipation: Maybe<boolean>;

  @Field(type => Boolean, { default: v => v ?? false })
  sharedWithLecturers: Maybe<boolean>;

  override toString() {
    return this.title ?? '';
  }
}
